import useSWR from "swr";
import { fetcher } from "../config/axiosConfig.ts";
import { BaseUrl, swrOptions } from "../const.ts";

export function usePrivacy() {
  const { data, error, isLoading } = useSWR(
      `${BaseUrl}/properties-ms/property/key/privacy`,
      fetcher,
      swrOptions
  );

  return {
    data: data?.body,  // Extract the body directly like in the old code
    error,
    isLoading,
  };
}
